module.exports = __webpack_public_path__ + "static/media/made_in_sa.13591a48.jpg";